import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationData, LocationState } from './types';
import { filterAndSortLocations, getOpenNowLocation, mockLocationData } from './utils';
import { getCurrentLabelsJson } from '../labels/labels.selector';

export const getLocationState =
  createFeatureSelector<LocationState>('locationState');

export const selectLocationState = createSelector(
  getLocationState,
  (state: LocationState) => state
);

export const getLocationData = createSelector(
  selectLocationState,
  (state: LocationState) => state.LocationData
);

export const getSelectedLocation = createSelector(
  getLocationData,
  (state: LocationData) => state.selectedLocation
);

export const getSearchFilters = createSelector(
  getLocationState,
  (state: LocationState) => state.searchFilters
);

export const getSearchResults = createSelector(
  getLocationState,
  (state: LocationState) => state.searchResults
);

export const getFilteredSearchResults = (flow: string ):MemoizedSelector<any, any> => createSelector(
  getSearchFilters,
  getSearchResults,
  getCurrentLabelsJson,
  (filters, results, labels: any) => {
    if(!results) return null
    return filterAndSortLocations(filters, results, labels, flow)
  }
)